var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full flex flex-col",attrs:{"id":"app"}},[_c('router-view'),(_vm.showAIFloatingButton)?_c('FloatingAIButton',{attrs:{"has-new-message":_vm.hasNewAIMessage,"unread-count":_vm.aiUnreadCount,"ai-assistant-route":"/ai-assistant"},on:{"click":_vm.trackAIClick,"quick-action":_vm.handleQuickAction}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }